import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Table} from '@devexpress/dx-react-grid-material-ui';
import {makeStyles} from '@material-ui/core';
import {blue} from '@material-ui/core/colors';
import {useStyles} from 'Utility/styles';

const highlightStyles = makeStyles(({theme}) => ({
  selected: {
    background: blue['200'],
    '&:hover': {
      background: blue['300'],
      cursor: 'pointer',
    },
  },
}));

export const CustomRowComponent = (props) => {
  const otherStyles = highlightStyles();
  const classes = useStyles();
  const {className, onToggle, selectByRowClick, highlighted, ...restProps} =
    props;
  const handleClick = useCallback(
    (e) => {
      if (!selectByRowClick) {
        return;
      }
      e.stopPropagation();
      onToggle();
    },
    [selectByRowClick, onToggle],
  );

  return (
    <Table.Row
      {...restProps}
      className={clsx({[classes.tableRow]: !highlighted}, className, {
        [otherStyles.selected]: highlighted,
      })}
      onClick={handleClick}
    />
  );
};

CustomRowComponent.propTypes = {
  className: PropTypes.string,
  onToggle: PropTypes.func,
  selectByRowClick: PropTypes.bool,
  highlighted: PropTypes.bool,
};

CustomRowComponent.defaultProps = {
  className: '',
  onToggle: null,
  selectByRowClick: false,
  highlighted: false,
};
